import {DOCUMENT, inject} from '@angular/core'
import {takeUntilDestroyed} from '@angular/core/rxjs-interop'
import {TranslateService} from '@ngx-translate/core'

// keeps <html lang> in sync with the active translation, otherwise the static lang="en" makes browsers (e.g. Edge) offer to translate an already localized page
export function injectDocumentLang(): void {
  const translate = inject(TranslateService)
  const document = inject(DOCUMENT)
  const setLang = (lang: string | null | undefined) => {
    if (lang) document.documentElement.lang = lang
  }

  setLang(translate.getCurrentLang())
  translate.onLangChange.pipe(takeUntilDestroyed()).subscribe((event) => setLang(event.lang))
}
